import React, { useEffect } from "react";
import { BooleanParam, StringParam, useQueryParam } from "use-query-params";
import { useAuth } from "../../context/AuthContext";
import { useSkuState } from "../../context/SkuContext";
import { useUiState } from "../../context/UiContext";
import { getSkuList } from "../../services/mongoApiService";
import { Sku, SkuType } from "../../types/Sku";
import {
  avatarsAssetMapping,
  silverPackagesAssetsMappings,
} from "../../utils/marketplaceAssetsMapping";
import * as Realm from "realm-web";
import Footer from "../Footer";
import LoginModal from "../Modals/LoginModal";
import RegisterModal from "../Modals/RegisterModal";
import ResetModal from "../Modals/ResetModal";
import Navbar from "../Navbar";
//@ts-ignore
import { useRealmApp } from "../../utils/RealmApp";
import { executeImxLoginCallback, passportInstance } from "../../integrations/imx";

const Layout = ({
  children,
  location,
}: {
  children: React.ReactNode;
  location: any;
}) => {
  const realmApp: Realm.App = useRealmApp();
  const { currentUser } = realmApp;

  //IMX LOGIN
  const [code] = useQueryParam("code", StringParam);
  const [state] = useQueryParam("state", StringParam);

  useEffect(() => {
    console.log("IMX PASSPORT CODE AND STATE", `${code}, ${state}`);
    if (code !== undefined && state !== undefined && passportInstance) {
      executeImxLoginCallback();
    }
  }, [code, state]);
  //IMX LOGIN

  const {
    state: { isLoginModelOpen, isRegisterModelOpen, isResetModelOpen }, //use context state as well, in case state needed
    actions: {
      setIsLoginModalOpen,
      setIsRegisterModalOpen,
      setIsResetModalOpen,
    }
  } = useAuth();

  const {
    actions: { setSku },
  } = useSkuState();
  //to set query params, so user can bookmark it
  const [loginQuery] = useQueryParam("login", BooleanParam);
  const [registerQuery] = useQueryParam("register", BooleanParam);
  const [resetQuery] = useQueryParam("reset", BooleanParam);

  //global loader
  const {
    state: { isLoading, toastState },
    actions: { setIsLoading },
  } = useUiState();

  useEffect(() => {
    getAndSetSkuList();
  }, [currentUser?.isLoggedIn]);

  const getAndSetSkuList = async () => {
    setIsLoading(true);
    try {
      //call realm function if logged in else call API Endpont
      let skuList: Sku[] = [];

      if (currentUser?.isLoggedIn) {
        skuList = (await currentUser?.functions?.getSkuList()) as Sku[];
        console.log("CALLED REALM FUNCTION FOR SKU ", skuList);
      } else {
        skuList = await getSkuList();
        console.log("CALLED API ENDPOINT FOR SKU ", skuList);
      }
      setSku(
        skuList.map((sku) => {
          //parse the content
          const parsedContent: any[] = sku?.content && JSON.parse(sku.content);
          if (parsedContent && parsedContent.length > 0) {
            sku.parsedContent = parsedContent[0];
          }
          if (sku.type === SkuType.SILVER_PACKAGE) {
            const silverAssetMapping = silverPackagesAssetsMappings.find(
              (mp) => mp._id === sku._id
            );
            return { ...silverAssetMapping, ...sku };
          }
          if (sku.type === SkuType.AVATAR) {
            const avatarAssetMapping = avatarsAssetMapping.find(
              (mp) => mp._id === sku._id
            );
            return { ...avatarAssetMapping, ...sku };
          }
          return sku;
        })
      );
    } catch (e) {
      console.log("Error while fetching SKU list");
    }
    setIsLoading(false);
  };

  return (
    <>
      <Navbar />
      {isLoading && <div id="cover-spin"></div>}
      {toastState.type !== 0 && (
        <div
          className={`toast-container ${
            toastState.type === 1 ? "bg-gray-200" : "bg-red"
          } text-gray-700 text-[1.25rem] px-6 py-4 rounded-lg shadow-lg fixed top-10 mx-3 lg:right-10 lg:mx-0 mt-10 z-[100]`}
        >
          {toastState.msg}
        </div>
      )}
      {children}
      <LoginModal
        isVisible={loginQuery || false}
        location={location}
        onClose={() => setIsLoginModalOpen(false)}
      />
      <RegisterModal
        isVisible={registerQuery || false}
        onClose={() => setIsRegisterModalOpen(false)}
      />
      <ResetModal
        isVisible={resetQuery || false}
        onClose={() => setIsResetModalOpen(false)}
      />
      <Footer />
    </>
  );
};

export default Layout;
